import { Fragment } from 'react'

import {
  Requirement,
  RequirementID,
  RequirementsList,
  Title,
  Wrapper,
} from './styles'
import { RequirementsProps } from './types'

export function Requirements({ blocks }: RequirementsProps) {
  return (
    <Wrapper>
      {blocks.map(({ title, requirements }) => (
        <Fragment key={title}>
          <Title as="h4">{title}</Title>
          <RequirementsList>
            {requirements.map(({ id, text }) => (
              <Requirement key={id}>
                <RequirementID>{id}</RequirementID>
                {text}
              </Requirement>
            ))}
          </RequirementsList>
        </Fragment>
      ))}
    </Wrapper>
  )
}
